import type { CSSProperties } from "react";
import "./loadOverlay.css";

const LoadOverlay = ({ text, isTransparent }: { text: string; isTransparent?: boolean }): JSX.Element => {
    const styleOverride: CSSProperties = {};
    if (isTransparent) styleOverride.background = "none";
    return (
        <div style={styleOverride} className="loadOverlay">
            <div className="loadStatusWrap">
                <div className="loadIndicator">L</div>
                <span className="loadStatusText">{text}</span>
            </div>
        </div>
    );
};

export default LoadOverlay;
